<div class="content1">
  <div class="step-row">
    <div class="step"></div>
    <div class="step on"></div>
  </div>

  
  <div>
    <h1 class="page-title">Multi-Factor Authentication</h1>
    <p class="page-sub"></p>
  </div>

    <form class="glass">
        <div class="card-body">
        <app-code-input 
            title="" 
            [loading]="false" 
            [backTitle]="'Resend Code'"
            [nextTitle]="'Submit'"
            (onReset)="resendSMS()"
            (onNext)="confirmSMS($event)">
            <p>We sent a code to your <b>phone number</b>, please enter the code above to complete your multifactor authentication. <b>Your code is valid for the next 15 minutes.</b></p>
            <p>If you consistently do not receive the code, please contact <i>info@rondeivu.com</i></p>
        </app-code-input>
        </div>
    </form>

</div>



